/**
 * Landing page background image resolver.
 *
 * Background is selected by:
 *  1. `?bg=` query parameter — image name without extension (e.g. ?bg=babe-3)
 *  2. whitelabel.wantedGender === 'shemale' → shemale default
 *  3. Fallback to mature default
 *
 * This is client-side only — the ?bg= value just determines which
 * image path the browser requests from /images/landings/.
 */

const DEFAULT_BACKGROUNDS: Record<string, string> = {
    shemale: 'shemale-3.webp',
    default: 'mature-bg9.webp',
};

export function getLandingBackground(searchParams: URLSearchParams, wantedGender?: string): string {
    const bg = searchParams.get('bg');

    if (bg) {
        return `/images/landings/${bg}.webp`;
    }

    if (wantedGender === 'shemale') {
        return `/images/landings/${DEFAULT_BACKGROUNDS['shemale']}`;
    }

    return `/images/landings/${DEFAULT_BACKGROUNDS['default']}`;
}
